import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevrons-left', 'ChevronsLeft', [["path",{"d":"M11 7l-5 5l5 5"}],["path",{"d":"M17 7l-5 5l5 5"}]]);